// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"556":"SweftWorkspace","741":"AdminWorkspace","874":"SuperAdminWorkspace"}[chunkId] || chunkId) + "." + {"233":"5aba09833f5b41094b32","556":"919be11d40aa664cf2ec","654":"51191a5a2e34139aa43e","741":"5f1b6e3dd1a07d2f08f5","874":"6dde2b5607978372dbce"}[chunkId] + ".css";
};